module.exports = __webpack_public_path__ + "img/tournament-2021-rocket-league.87261a4d.jpg";